import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { fetchApi } from "../config";

import Header from "../components/Header";
import Footer from "../components/Footer";
import GlobalCta from "../components/global/GlobalCta";
import PageHero from "../components/global/PageHero";
import CareerPerks from "../components/career/CareerPerks";
import JobList from "../components/career/JobList";
import ApplyForm from "../components/career/ApplyForm";

export default function Career() {
    const location = useLocation();
    const requestedPosition = new URLSearchParams(location.search).get("position") || "";
    const [position, setPosition] = useState(requestedPosition);
    const [vacancies, setVacancies] = useState(null);
    const [vacLoading, setVacLoading] = useState(false);
    const [vacError, setVacError] = useState("");

    useEffect(() => {
        let mounted = true;
        async function load() {
            setVacLoading(true);
            try {
                const res = await fetchApi("get_vacancies.php");
                if (!mounted) return;
                if (res && Array.isArray(res.Vacancies)) {
                    setVacancies(res.Vacancies);
                } else {
                    setVacancies([]);
                }
            } catch (err) {
                if (!mounted) return;
                setVacError(err.message || "Failed to load vacancies");
            } finally {
                if (mounted) setVacLoading(false);
            }
        }
        load();
        return () => { mounted = false; };
    }, []);

    useEffect(() => {
        if (!requestedPosition) return undefined;

        const frame = window.requestAnimationFrame(() => {
            document.getElementById("apply")?.scrollIntoView({ behavior: "smooth" });
        });

        return () => window.cancelAnimationFrame(frame);
    }, [requestedPosition]);

    useEffect(() => {
        if (location.hash !== "#careers") return undefined;

        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        const frame = window.requestAnimationFrame(() => {
            document.getElementById("careers")?.scrollIntoView({ behavior: "smooth", block: "start" });
        });

        return () => window.cancelAnimationFrame(frame);
    }, [location.hash]);

    const handleApply = (role) => {
        setPosition(role);
        document.getElementById("apply")?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Careers" title="Not just a job — a place to build.">
                    At Kudosta you're an ideapreneur: free to express and implement your ideas. Come, work and grow with us — and help ship software that quietly runs businesses across the world.
                </PageHero>

                <CareerPerks />

                <JobList onApply={handleApply} vacancies={vacancies} />

                <ApplyForm position={position} onPositionChange={setPosition} positions={vacancies ? vacancies.map(v => v.job_title) : null} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
